// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"864":"869e358f","951":"75dc60fc"}[chunkId] + ".chunk.js";
};